'use strict';

const moment = require('moment');

require('./easter');
require('./locale');
require('./add-subtract');

module.exports.moment = moment;
module.exports.utils = require('./utils');
